<script>
import Layout from '@layouts/main';
import AdminForm from '@views/admins/form';

export default {
  components: {
    Layout,
    AdminForm,
  },
  page() {
    return {
      title: this.$t('titles.create_admin'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.admins'),
          to: { name: 'admins.index' },
        },
        {
          text: this.$t('titles.create_admin'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({
        name: 'admins.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_admin')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <AdminForm @submitted="create" />
    </b-card>
  </Layout>
</template>
